"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = _interopRequireDefault(require("./styles"));
var _Label = _interopRequireDefault(require("../Label"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledTextarea = _styledComponents.default.textarea(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    :hover,\n    :focus {\n        border-color: ", "\n    }\n"])), function (props) {
  return props.theme.primaryColor;
});
var Textarea = (0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
    errorMsg = _ref.errorMsg,
    hasError = _ref.hasError,
    id = _ref.id,
    placeholder = _ref.placeholder,
    readOnly = _ref.readOnly,
    value = _ref.value,
    _onChange = _ref.onChange,
    onClick = _ref.onClick,
    labelClassName = _ref.labelClassName,
    onKeyPress = _ref.onKeyPress,
    label = _ref.label,
    onBlur = _ref.onBlur;
  var textArea = /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles.default.root, className)
  }, /*#__PURE__*/_react.default.createElement(StyledTextarea, {
    className: (0, _classnames2.default)(_styles.default.textarea, _defineProperty({}, _styles.default.hasError, hasError)),
    id: id,
    placeholder: placeholder,
    readOnly: readOnly,
    ref: ref,
    value: value,
    onChange: function onChange(e) {
      return _onChange(e.target.value, e);
    },
    onClick: onClick,
    onKeyPress: onKeyPress,
    onBlur: onBlur
  }), errorMsg && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.error
  }, errorMsg));
  return label ? /*#__PURE__*/_react.default.createElement(_Label.default, {
    className: labelClassName,
    text: label
  }, textArea) : textArea;
});
Textarea.propTypes = {
  className: _propTypes.default.string,
  errorMsg: _propTypes.default.string,
  hasError: _propTypes.default.bool,
  id: _propTypes.default.string,
  label: _propTypes.default.string,
  labelClassName: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onClear: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onKeyPress: _propTypes.default.func,
  onBlur: _propTypes.default.func
};
Textarea.displayName = 'Textarea';
var _default = exports.default = (0, _react.memo)(Textarea);